import common from './common.json'
import startPage from './startPage.json'
import legal from './legal.json'
import finish from './finish.json'
import sectionA from './sectionA.json'
import sectionB from './sectionB.json'
import sectionC from './sectionC.json'
import sectionD from './sectionD.json'
import sectionE from './sectionE.json'
import sectionF from './sectionF.json'
import sectionG from './sectionG.json'
import sectionH from './sectionH.json'
import sectionI from './sectionI.json'
import sectionJ from './sectionJ.json'
import sectionK from './sectionK.json'
import sectionL from './sectionL.json'
import sectionReview from './sectionReview.json'
import hinweisblatt from './hinweisblatt.json'

const resources = {
  common,
  startPage,
  legal,
  finish,
  sectionA,
  sectionB,
  sectionC,
  sectionD,
  sectionE,
  sectionF,
  sectionG,
  sectionH,
  sectionI,
  sectionJ,
  sectionK,
  sectionL,
  sectionReview,
  hinweisblatt,
}

export default resources
